import React from 'react';
import partial from 'lodash/partial';
import PaymentModal from 'project/components/brief/payment_modal_1_1';

/**
 * 1-1 project payment CTA.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const Pay1to1 = ({showPaymentModal, showingPaymentModal}) => (
  <div>
    <div className="pay-1-1">
      <h4>Payment Required</h4>
      <p>Your payment is required in order for work to begin on this project.</p>
      <p>
        We guarantee your satisfaction. We'll pay the creative and you'll get full intellectual
        property rights to the work when you approve the final files.
      </p>
      <button onClick={partial(showPaymentModal, true)} className="btn btn-primary">
        Pay now
      </button>
    </div>
    {showingPaymentModal && <PaymentModal show={showPaymentModal}/>}
  </div>
)

export default Pay1to1;



// WEBPACK FOOTER //
// ./project/components/brief/pay_1_1.jsx